<template>
  <data-table 
    v-model="page" 
    :headers="headers"
    :items="keys"
    class="elevation-1"
    @refresh="load"
    :loading="dataLoading"
  >
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
      <v-icon color="red" small @click="deleteItem(item)">
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
    </template>
  </data-table>
</template>

<script>
import SettingsStrings from "./SettingsStrings.js"
export default {
  data: () => ({
    page: 1,
    dialog: false,
    dataLoading: true,
    headers: [
      { text: 'Key', align: 'start', sortable: true, value: 'label' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    keys: []
  }),
  created: function () {
    this.load()
  },
  methods: {
    load() {
      this.$api.listAPIKeys(this.username, this.callBack(response => {
        this.keys = response
      }, undefined, ()=> {this.dataLoading = false}))
    },
    editItem(item) {
      this.$router.push({ name: 'EditAccessToken', params: { ApiKey: item.label }})
    },

    deleteItem(item) {
      const label = item.label
      this.alert("confirm", SettingsStrings({label:label}, "delete_access_token"), undefined, () => {
        this.$api.deleteAPIkey(label, this.username, this.callBack(
          this.load
        ))
      })
    },
  },
}
</script>

<style scoped>
.v-data-table {
  width: fit-content;
  max-width: 100%;
}
</style>